var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"smvp-live-badge-container",attrs:{"aria-label":_vm.labels.ariaLabel}},[_c('badge',{staticClass:"smvp-live-badge"},[_vm._v("Live")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }